export const CUSTOM_DATE_FILTER_TABLE_TYPE = "CUSTOM_DATE_FILTER_TABLE_TYPE";
export const CUSTOM_SELECT_FILTER_TABLE_TYPE = "CUSTOM_SELECT_FILTER_TABLE_TYPE";
export const DELAY_FILTER_TIME = 1000;
